import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { useAuthedApi } from "./api";

const KEY = "csm_location";
const LocCtx = createContext({ location: null, setLocation: () => {}, askOpen: false, setAskOpen: () => {} });

const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; } };
const store = (v) => (v ? localStorage.setItem(KEY, JSON.stringify(v)) : localStorage.removeItem(KEY));

export function LocationProvider({ children }) {
  const { isSignedIn } = useAuth();
  const api = useAuthedApi();
  const [location, setLoc] = useState(read);
  const [askOpen, setAskOpen] = useState(false);

  const setLocation = useCallback((v) => {
    setLoc(v);
    store(v);
    if (isSignedIn && v?.city) api("put", "/me/location", { state: v.state, city: v.city }).catch(() => {});
  }, [isSignedIn, api]);

  useEffect(() => {
    // Signed-in users: the city saved on their account wins, so it follows them across devices.
    if (!isSignedIn) return;
    api("get", "/me").then((me) => {
      const saved = me.location;
      const local = read();
      if (saved?.city) { if (saved.city !== local?.city || saved.state !== local?.state) { setLoc(saved); store(saved); } }
      else if (local?.city) api("put", "/me/location", local).catch(() => {});
    }).catch(() => {});
  }, [isSignedIn]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const sync = (e) => e.key === KEY && setLoc(read());
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);
  return <LocCtx.Provider value={{ location, setLocation, askOpen, setAskOpen }}>{children}</LocCtx.Provider>;
}

export const useUserLocation = () => useContext(LocCtx);
